import "./style.css";
import "ui.design-tokens";
import "ui.fonts.montserrat";

export const MessageType = {
	TYPE_OK: 'ok',
	TYPE_ERROR: 'error',
	TYPE_WARNING: 'warning',
	TYPE_INTRO : 'intro',
	TYPE_GLOBAL : 'global',
	TYPE_ALERT_WARNING : 'alert_warning',
};

export class Message extends BX.Network.Component
{
	constructor(parameters = {})
	{
		super(parameters, {autoUpdate: true});

		this.rootNode = BX.create('DIV', {
			events: {
				click: BX.delegateEvent(
					{
						attribute: 'data-action'
					},
					() => {
						this.callEvent('action', []);
					}
				)
			}
		})
	}

	description()
	{
		return {
			message: {
				type: String,
				defaultValue: ''
			},
			linkMessage: {
				type: String,
				defaultValue: ''
			},
			detailMessage: {
				type: Array,
				defaultValue: []
			},
			type: {
				type: String,
				defaultValue: ''
			},
			linkButton: {
				type: String,
				defaultValue: ''
			},
			linkButtonTitle: {
				type: String,
				defaultValue: ''
			}
		}
	}

	onAction(action, element)
	{
		if (this.$data.linkButton)
		{
			window.location.href = this.$data.linkButton;
		}
	}

	render()
	{
		if(this.$data.message)
		{
			BX.adjust(this.rootNode, {

				html: Mustache.render(
`
{{#typeError}}
	<div class="b24-network-auth-form-field-error-wrap">
		<span class="b24-network-auth-form-field-error">{{{data.message}}}</span>
	</div>
{{/typeError}}
{{#typeIntro}}
	<div class="b24-network-auth-form-intro">
		<span class="b24-network-auth-form-intro-text">{{{data.message}}}</span>
	</div>
{{/typeIntro}}
{{#typeWarning}}
	<div class="b24-network-auth-form-warning">
		<div class="b24-network-auth-form-warning-inner">
			<span class="b24-network-auth-form-warning-text">{{{data.message}}}</span>
			{{#data.linkMessage}}
			<span class="b24-network-auth-form-warning-link" data-action="link">{{{data.linkMessage}}}</span>
			{{/data.linkMessage}}
		</div>
	</div>
{{/typeWarning}}
{{#typeGlobal}}
	<div class="b24-network-auth-form-error{{^detailMessage}} b24-network-auth-form-error-common{{/detailMessage}}">
		<span class="b24-network-auth-form-error-icon"></span>
		<span class="b24-network-auth-form-error-text">
		{{#detailMessage}}
			<span class="b24-network-auth-form-detail">{{{detailMessage}}}</span>
		{{/detailMessage}}
		{{^detailMessage}}
			{{{data.message}}}
		{{/detailMessage}}
		</div>
{{/typeGlobal}}
{{#typeAlertWarning}}
	<div class="ui-alert ui-alert-warning b24-network-auth-form-alert b24-network-auth-form-status-text">
		<span class="ui-alert-message">{{{data.message}}}</span>
	</div>
{{/typeAlertWarning}}
{{#typeOk}}
	<div class="b24-network-auth-form-status b24-network-auth-form-status-wide">
		<span class="b24-network-auth-form-status-text">{{{data.message}}}</span>
	</div>
	{{#data.linkButton}}
	<div class="b24-network-auth-form-btn-block">
		<button class="ui-btn ui-btn-md ui-btn-success ui-btn-round b24-network-auth-form-btn" data-action="link">{{{data.linkButtonTitle}}}</button>
	</div>
	{{/data.linkButton}}
{{/typeOk}}
`,
					{
						typeError: this.$data.type === MessageType.TYPE_ERROR,
						typeIntro: this.$data.type === MessageType.TYPE_INTRO,
						typeWarning: this.$data.type === MessageType.TYPE_WARNING,
						typeGlobal: this.$data.type === MessageType.TYPE_GLOBAL,
						typeAlertWarning: this.$data.type === MessageType.TYPE_ALERT_WARNING,
						typeOk: ![
							MessageType.TYPE_ERROR,
							MessageType.TYPE_WARNING,
							MessageType.TYPE_INTRO,
							MessageType.TYPE_GLOBAL,
							MessageType.TYPE_ALERT_WARNING,
						].includes(this.$data.type),
						data: this.$data,
						detailMessage: this.$data.detailMessage.length <= 0
							? ''
							: this.$data.detailMessage.join('</span><span class="b24-network-auth-form-detail">'),

						message: this.$localization,
					}
				)
			});

			if (this.$data.linkButton)
			{
				this.on('action', this.onAction);
			}

			return this.rootNode;
		}
		else
		{
			return '';
		}
	}
}

